export default {
	state: {
		dadosSimuladorSeguro: {}
	},
	getters: {
		"dadosSimuladorSeguro": state => state.dadosSimuladorSeguro
	},
	mutations: {
		setDadosSimuladorSeguro(state, payload) {
			state.dadosSimuladorSeguro = payload
		}
	},
	actions: {
		atualizarEstadoDadosSimuladorSeguro({ commit }, payload) {
			commit('setDadosSimuladorSeguro', payload)
		}
	}
};